// extracted by mini-css-extract-plugin
export default {"main_container":"Weather_main_container__1Sg+C","image":"Weather_image__rAhbL"};